export default function cx(...classNames) {
  return classNames.filter(Boolean).join(' ');
}
//# sourceMappingURL=cx.js.map